<style lang="sass">
Table
  text-align: center
.top
  margin: 30px auto
.pages
  margin: 30px auto
</style>
<template>
    <Card>
        <div class="top">
            <Button type="success" :disabled="buttonList.addDisabled" @click="addData(1)" style="margin-right:8px;">添加</Button>
            <Button type="primary" :disabled="buttonList.editDisabled" @click="addData(2)" style="margin-right:8px;">修改</Button>
            <Button type="error" @click="todelData" :disabled="buttonList.delDisabled">删除</Button>
        </div>
         <Table :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" ref="selection" @on-selection-change="selectChange" ></Table>
          <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[10,20,30,50]" placement="top" class="pages"/>
          <!-- 编辑 / 添加  模态框组件 -->
           <ModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>
        <!-- 删除弹框组件 -->
        <DeleteDialog ref="deleteChild" @ievent = "ievent"></DeleteDialog>
    </Card>
</template>
<script>
import Side from '../common/side.vue'
import common from '@/common/common.js';
import ModelBox from './addModel';
import moment from 'moment';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件

    export default {
        name: "merchantAdmin",
        components: {
            ModelBox,
            DeleteDialog
        },
        data(){
            return{
                selectChangeData: [],
                loading: true,
                type:1,//弹框打开类型 1添加 2编辑
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                addBox:{//规格弹框组
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:20,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                titleName: [
                    { //多选框
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },

                    {
                        title: '名称',
                        key: 'source_name',
                    },
                    {
                        title: '分类',
                        key: 'cate_name',
                    },
                    {
                        title: '缩略图',
                        key: 'thumb',
                        render: (h, params) => {
						  return h('div', [h('img', {
									  style: {
										 width: '40px',
										 height: '40px',
									  },
									  attrs: {
										src:this.config.sourceUrl + params.row.thumb,
                                      },
                                      on: {
                                            click: () => { this.jumpLisk(params.row) }
                                        }
                                  })]
                                  )
						}
                    },
                    {
                        title: '单价',
                        key: 'price',
                    },
                    {
                        title: '单位',
                        key: 'unit',
                    },
                    {
                        title: '状态',
                        key: "status",
                        sortable: 'custom',
                        render: (h, params) => {
                            let statusText = '显示'
                            if(params.row.status == 2){
                                statusText = '隐藏'
                            }
						  return h('span', statusText)
						}
                    },
                    {
                        title: '排序',
                        key: "sort",
                        sortable: 'custom'
                    },
                    {
                        title: '创建时间',
                        key: "created_at",
                        sortable: 'custom'
                    }
                ],
            }
        },
        created() {
            this.getData();
        },
        methods: {
            jumpLisk(data){
                window.open('/storage/'+data.thumb)
            },
            todelData() {
                this.$refs.deleteChild.showit();
            },
            // 批量删除
            ievent() {
                let getData = {
                    id: this.tableList.hasSelectData.id,
                }
                this.axios.post(this.config.urlArray.sourceDestroy, getData).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.clearbtnStatus();
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    common.msg('error','删除失败')
                })
            },
            getData() {//获取数据
                let getData = {
                    params: {
                        page: this.page.current,
                        pagesize: this.page.pageSize,
                        sortfield: this.page.key,
                        ascDesc: this.page.order
                    }
                }
                this.axios.get(this.config.urlArray.sourceShow, getData).then((result) => {
                    common.ajaxMsg(result.data);
                    let resData = result.data.data.list.map((item,index)=>{
                        item.cate_name = item.cate.cate_name
                        return item
                    })
                    //处理数组
                    this.tableList.tableData = resData
                    this.page.total = result.data.data.paging.total
                    this.loading = false
                }).catch((err) => {
                    common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom(data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            addData(type) {  //添加或编辑数据
                this.addBox.showModel = true
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            selectChange(res) { //控制编辑和删除按钮的可用状态
                this.selectChangeData = res
                if(res.length == 1){
                    this.buttonList.editDisabled = this.buttonList.delDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                this.getData();
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            clearbtnStatus() { //删除后清空编辑数据 与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.addBox.editFormData ={}
                this.tableList.hasSelectData = {}
            },
        }
    }
</script>
